import { useState } from '#imports'

import { getBrazeInstance } from '@backmarket/nuxt-module-tracking/getBrazeInstance'

import type { BrazeContentCard } from './PersonalizedFeed.utils'

/**
 * Fetch and subscribe to Braze Content Cards.
 */
export const useBrazeCards = () => {
  const cards = useState<BrazeContentCard[]>('braze-cards', () => [])

  function getCardsFromBraze() {
    const instance = getBrazeInstance()
    let cachedCards: BrazeContentCard[] = []
    if (!instance || cards.value.length) {
      return
    }

    instance.requestContentCardsRefresh()
    cachedCards = instance.getCachedContentCards()?.cards || []

    if (cachedCards.length > 0) {
      cards.value = cachedCards
    } else {
      instance.subscribeToContentCardsUpdates((updates) => {
        cards.value = updates.cards
      })
    }
  }

  return {
    cards,
    fetchCards: getCardsFromBraze,
  }
}
